import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from  'axios'
import Vant from 'vant';
import { Lazyload } from 'vant'
import 'vant/lib/index.css';
import '@/assets/css/reset.css'
import '@/assets/js/flexible.js'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(Vant);
Vue.use(Lazyload)
// 配置请求的根路径
axios.defaults.baseURL = '/api'
// 挂载到原型对象之前 先设置拦截器 通过axios请求拦截器添加token，保证拥有获取数据的权限
axios.interceptors.request.use(config => {

  return config
})
// 在 response 拦截器中， 隐藏进度条 NProgress.done()
axios.interceptors.response.use(config => {
  // NProgress.done()
  return config
})
// 原型上挂载axios， 所有组件都可以通过this.$http来请求
Vue.prototype.$axios = axios





new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
